export class Unit {
  id = 0;
  text = '';
  category = '';
  isDefault = false;
  displayName = '';
}
